export function hasChanges(pristineModel: any, currentModel: any) {
  const pristine = JSON.stringify(pristineModel);
  const current = JSON.stringify(currentModel);
  return pristine !== current;
}
